import { Link } from "react-router-dom";
import { Layout } from "../layouts";

export const Error404 = () => {
  return (
    <Layout>
      <div className="d-flex flex-column justify-content-center align-items-center">
        <div className="text-center py-5">
          <h1 className="fw-bold text-danger" style={{ fontSize: "48px" }}>
            404
          </h1>
          <p className="fs-4">Page Not Found</p>
          <div>
            <Link className="btn btn-primary" to={"/menu"}>
              Explore Our Menu
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};
